// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import * as React from '@plesk/ui-library';

export default React;
export * from '@plesk/ui-library';



//////////////////
// WEBPACK FOOTER
// ../react-compat.js
// module id = 2
// module chunks = 1 2 3 4 5 6